import * as React from 'react'
import * as ReactDOM from 'react-dom'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface StatefulData<T = {}> {
  onUnmount: () => void
  getState(): T
  setState(state: T): void
  refresh: () => void
  getEl(): HTMLElement
}

interface Props<T> extends React.HTMLProps<T> {
  initial: T
  draw: (data: StatefulData<T>) => JSX.Element
}

export class Stateful<T> extends React.Component<Props<T>, T> {
  private unmountHandler: () => void

  constructor(props: Props<T>) {
    super(props)
    this.state = props.initial
  }

  public override componentWillUnmount(): void {
    if (this.unmountHandler) {
      this.unmountHandler()
    }
  }

  public override render(): React.ReactNode {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this
    const data: StatefulData<T> = {
      getState(): T {
        return self.state
      },
      setState(state: T): void {
        self.setState(state)
      },
      refresh(): void {
        self.forceUpdate()
      },
      getEl(): HTMLElement {
        return ReactDOM.findDOMNode(self) as HTMLElement
      },
      set onUnmount(cb: () => void) {
        self.unmountHandler = cb
      }
    }
    return this.props.draw(data)
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const renderStateful = <T extends {}>(
  initial: T,
  draw: (data: StatefulData<T>) => JSX.Element
): JSX.Element => {
  return <Stateful initial={initial} draw={draw} />
}
